// @ts-ignore
import defaultValue from 'lodash.defaultto';
import { Response } from './Response';

export class OrderStatusResponse extends Response {
  get status() {
    return this.emptyIfNotDefined(this.data.status);
  }

  get parcels() {
    return this.nullIfNotDefined(this.data.parcels);
  }

  private nullIfNotDefined(value: Nullable<string | number>) {
    return defaultValue(value, null);
  }

  private emptyIfNotDefined(value: Nullable<string | number>) {
    return defaultValue(value, '');
  }
}
